import NoValue from 'Components/Atoms/NoValue/NoValue';
import RadioButton from 'Components/Atoms/RadioButton/RadioButton';
import RadioButtonGroup from 'Components/Molecules/RadioButtonGroup/RadioButtonGroup';
import { useMemo } from 'react';

const RadioField = ({
    isEdit,
    value,
    onChange,
    fieldProperties
}: any) => {
    const groupId = useMemo(() => Math.random(), []);
    if (!isEdit) {
        return fieldProperties?.list?.find((i: any) => i?.value === value)?.label ?? <NoValue />;
    }

    return <RadioButtonGroup>
        { fieldProperties?.list?.map(i => {
            if (!i?.value || !i?.label) return <></>;

            return <RadioButton
                groupId={groupId}
                id={i.value}
                label={i.label}
                isActive={i.value === value}
                onChange={() => onChange(i.value)}
            />;
        }) }
    </RadioButtonGroup>;
}

export default RadioField;